<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title>
        <span class="text-body-1 primary--text">Editar Página</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <validation-alert :validationErrors="validationErrors" />
          <v-form ref="form" v-model="isValidFormDialog" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="editedItem.app_id"
                  :items="applications"
                  item-text="name"
                  item-value="id"
                  label="Aplicación"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="editedItem.module_id"
                  :items="modules"
                  :rules="moduleRules"
                  item-text="name"
                  item-value="id"
                  label="Módulo"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.name"
                  :rules="nameRules"
                  label="Nombre"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="editedItem.description"
                  :rules="descriptionRules"
                  name="description"
                  label="Descripción"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-switch v-model="editedItem.active" label="Estado"></v-switch>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close()"> Cancelar </v-btn>
        <v-btn
          color="blue darken-1"
          :loading="isLoading"
          :disabled="isLoading"
          @click="save()"
          text
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ValidationAlert from "@/components/global/ValidationAlert.vue";
import { $EventBus } from "@/main";
export default {
  name: "EditModuleDialog",

  props: {
    page: Object,
  },

  data: () => ({
    dialog: false,
    isLoading: false,
    isValidFormDialog: false,
    applicationRules: [(v) => !!v || "Campo requerido"],
    moduleRules: [(v) => !!v || "Campo requerido"],
    nameRules: [(v) => !!v || "Campo requerido"],
    descriptionRules: [(v) => !!v || "Campo requerido"],
    editedItem: {
      app_id: "",
      module_id: "",
      name: "",
      description: "",
      active: true,
    },
    defaultItem: {
      app_id: "",
      module_id: "",
      name: "",
      description: "",
      active: true,
    },
  }),

  computed: {
    applications() {
      return this.$store.getters["applications/getApplicationsList"];
    },
    modules() {
      return this.$store.getters["modules/getModulesList"];
    },
    validationErrors() {
      return this.$store.getters["pages/getValidationErrors"];
    },
  },

  watch: {
    page(val) {
      if (val && val.id) {
        this.dialog = true;
        this.editedItem = val;
        this.initialize();
      }
    },
    dialog(val) {
      val || this.close();
    },
    "editedItem.app_id"() {
      this.listenApplication();
    },
  },

  methods: {
    initialize() {},

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.$store.dispatch("pages/cleanValidationErrors");
        this.$refs.form.resetValidation();
      });
    },

    showSnack(color = "", text = "") {
      $EventBus.$emit("showSnack", { color, text });
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        try {
          await this.$store.dispatch("pages/updatePage", this.editedItem);
          this.showSnack("green", "Página actualizada");
          this.close();
        } catch (error) {}
        this.isLoading = false;
        this.$emit('resetFilter');
      }
    },

    listenApplication() {
      this.$store.dispatch("modules/getModulesList", {
        app_id: this.editedItem.app_id,
      });
    },
  },
  components: {
    ValidationAlert,
  },
};
</script>
